module.exports = __webpack_public_path__ + "img/ic_hub_device.0d8589b7.svg";